module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAKlBMVEUAlUMNmUP73krCzkgLmEO5y0gHl0PcJB+uyEgDlkPdJyCixEeYwUfeKyAMMZZZAAABGklEQVR42rXRQU4DMBDFUJoWDLS5/3VZelFVNFHsCzzNn49jXcarAiIzruN13RXWEdYRFvyiMG7jnzrCuqGsu8I6wg4QrfE53qq7wjrCuqGsu8I6wrqhrLvCOsI6wrZ+kRtfY9noCaqhDPoroCegJlaN7z2C/groCciHAvoroCOsG8oqYtX42SKsI6wbyrorrCOsG8pOX/HLc91QFhArxv0QQfcL64aybijrhrJuKOsI635h3S+sG8q6oawbyrqhrBvKuqGsJDQsGQpQeFQEGtFQQDeUdUNZN5R1Q1lHWPcL27lislY3lG0QvTF7A3KD3qA3Zm9AbtAbszcgN+iN2RuQG/QGvTF7A3KD3pi9AblBb9AbszcgNzjWHy9hbx3aUpThAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Republic of the Congo.png
// module id = 606
// module chunks = 0